import Environment from "@/enum/environment.enum";
import { GitType } from "@/enum/project.enum";
import { GIT_TYPE, SUBSCRIPTION_PLAN_TYPE } from "@brimble/models";

const config = {
  ENVIRONMENT: process.env.NEXT_APP_ENV as Environment,
  REFRESH_TOKEN: "brimble_refresh_token",
  ACCESS_TOKEN: "brimble_access_token",
  USER_DATA: "brimble_user_data",
  PAYSTACK_KEY: process.env.NEXT_PUBLIC_PAYSTACK_KEY as string,
  AVATAR_URL: "https://api.dicebear.com/7.x",
  UPLOAD_URL: "https://api.cloudinary.com/v1_1/dgqfojhx4/image/upload",
  PAYMENT_BASE_URL: process.env.NEXT_PUBLIC_PAYMENT_BASE_URL as string,
  AUTHORIZATION_CHARGE: process.env.NEXT_AUTHORIZATION_CHARGE as string,
  INTEGRATION_BASE_URL: process.env.NEXT_PUBLIC_INTEGRATION_BASE_URL as string,
  BASE_URL: process.env.NEXT_PUBLIC_BASE_URL as string,
  API_URL: process.env.NEXT_PUBLIC_API_URL as string,
  AUTH_API_URL: process.env.NEXT_PUBLIC_AUTH_URL || "https://auth.brimble.io",
  DOLLAR_RATE: Number(process.env.NEXT_PUBLIC_DOLLAR_RATE) || 1600,
  MEMBER_PRICE: Number(process.env.NEXT_PUBLIC_MEMBER_PRICE) || 5,
  SLACK_SUPPORT_PRICE:
    Number(process.env.NEXT_PUBLIC_SLACK_SUPPORT_PRICE) || 15,
  CONCURRENT_BUILD_PRICE:
    Number(process.env.NEXT_PUBLIC_CONCURRENT_BUILD_PRICE) || 15,
  supabaseConfig: {},
  CUSTOMER_CHAT_API: process.env.NEXT_PUBLIC_CUSTOMER_CHAT_API as string,
  PROJECT_LIMIT: process.env.NEXT_PUBLIC_PROJECT_LIMIT as string,
  AUTH_TOKEN: process.env.NEXT_PUBLIC_AUTH_TOKEN as string,
  HMAC_SECRET_KEY: process.env.NEXT_PUBLIC_HMAC_SECRET_KEY as string,
  DOMAIN_DISCOUNT_PERCENTAGE:
    (process.env.DOMAIN_DISCOUNT_PERCENTAGE as string) || "15",
  POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY as string,
  POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST as string,
  VISA_IMAGE:
    (process.env.NEXT_PUBLIC_VISA_IMAGE as string) ||
    "https://res.cloudinary.com/dgqfojhx4/image/upload/v1711631294/dashboard-assets/visa_leqrxq.svg",
  VERVE_IMAGE:
    (process.env.NEXT_PUBLIC_VERVE_IMAGE as string) ||
    "https://res.cloudinary.com/dgqfojhx4/image/upload/v1708776940/dashboard-assets/verve_xlgijt.png",
  MASTERCARD_IMAGE:
    (process.env.NEXT_PUBLIC_MASTERCARD_IMAGE as string) ||
    "https://res.cloudinary.com/dgqfojhx4/image/upload/v1708776793/dashboard-assets/card-light_g32xot.svg",
  SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL as string,
  SUPABASE_KEY: process.env.NEXT_PUBLIC_SUPABASE_KEY as string,
  SENTRY_TOKEN: process.env.NEXT_PUBLIC_SENTRY_AUTH_TOKEN as string,
  INSTATUS_APIKEY: process.env.NEXT_PUBLIC_INSTATUS_APIKEY as string,
  CENTRIFUGO_SOCKET: process.env.NEXT_PUBLIC_CENTRIFUGO_SOCKET as string,

  LOKI_URL: process.env.NEXT_PUBLIC_LOKI_URL as string,

  PRO_PLAN_PRICE: Number(process.env.NEXT_PUBLIC_PRO_PLAN_PRICE) || 15,
  PERSISTENT_STORAGE_PRICE:
    Number(process.env.NEXT_PUBLIC_PERSISTENT_STORAGE_PRICE) || 0.25,

  POSTMAN_API_DOCS_URL:
    process.env.NEXT_PUBLIC_POSTMAN_API_DOCS_URL ||
    "https://documenter.getpostman.com/view/11039127/2sB2jAc8fL#a059ff1a-93f5-4b73-91c6-11141cfe602d",

  NON_EDITABLE_ENV_NAMES: [
    "PORT",
    "BRIMBLE_DOCKER_REGISTRY_PASSWORD",
    "BRIMBLE_DOCKER_REGISTRY_USERNAME",
  ],

  PAID_PLANS: [
    SUBSCRIPTION_PLAN_TYPE.DeveloperPlan,
    SUBSCRIPTION_PLAN_TYPE.TeamPlan,
  ],

  FREE_PLAN_MESSAGE: "This feature is only available on paid plans.",

  SUPABASE_TABLE_NAME:
    (process.env.NEXT_PUBLIC_SUPABASE_TABLE_NAME as string) ||
    "BRIMBLE_DEPLOYMENT_LOGS",

  SERVICE_APPS: [
    "other",
    "docker",
    "laravel",
    "php",
    "python",
    "golang",
    "ruby",
  ],

  NON_DOCKER_SERVICE_APPS: ["other", "laravel", "php", "python", "golang"],

  DEFAULTS: {
    CPU: 0.5,
    MEMORY: 0.5,
    STORAGE: 1,
    BASE_PRICE: Number(process.env.NEXT_PUBLIC_BASE_PRICE) || 4,
  },
  GIT_TYPES: [
    GitType.GitHub,
    GitType.GitLab,
    GitType.Bitbucket,
    GIT_TYPE.GITHUB,
    GIT_TYPE.GITLAB,
    GIT_TYPE.BITBUCKET,
  ],
};
export default config;

export const cookieOptions: any = {
  maxAge: 60 * 60 * 24 * 30 * 12,
  secure: process.env.NEXT_APP_ENV !== "development",
  sameSite: "strict",
};

export const appId = Math.random().toString(36).slice(2);
